import { useEffect } from "react";

const STYLE_ID = "hide-global-nav";

export function useHideGlobalNav({ enabled = true } = {}) {
  useEffect(() => {
    if (!enabled || typeof document === "undefined") {
      return;
    }

    if (document.getElementById(STYLE_ID)) {
      return;
    }

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.innerHTML = `
      .chakra-ui nav,
      nav[role="navigation"],
      [data-testid="navigation"] {
        display: none !important;
      }
    `;

    document.head.appendChild(style);

    return () => {
      const existingStyle = document.getElementById(STYLE_ID);
      if (existingStyle) {
        document.head.removeChild(existingStyle);
      }
    };
  }, [enabled]);
}
